module.exports = __webpack_public_path__ + "img/iconNo13.93e927f2.png";